var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sidebar",style:({'padding-top': _vm.paddingTop}),attrs:{"id":"sidebar","data-disable-slide-animation":"true"}},[_c('div',{attrs:{"data-scrollbar":"true","data-height":"100%"}},[_c('sidebar-nav',{attrs:{"scrollTop":_vm.scrollTop}})],1)]),_c('div',{staticClass:"sidebar-bg"})])
}
var staticRenderFns = []

export { render, staticRenderFns }